import Vuex from 'vuex';
import Vue from 'vue';
import sgp from './modules/sgp';

// Load Vuex
Vue.use(Vuex);

// Create store
export default new Vuex.Store({
  modules: {
    sgp
  }
});